import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '@/lib/auth/route-guards'
import type { RouterAuthContext } from '@/lib/auth/router-context'

/**
 * Layout route for series section
 * Renders child routes via Outlet
 */
function SeriesLayout() {
  return <Outlet />
}

export const Route = createFileRoute('/app/series')({
  beforeLoad: async ({ context, location }) => {
    // Series management requires at least instructor role
    await requirePermission(context as RouterAuthContext, 'curriculum:view', {
      currentPath: location.pathname,
    })
  },
  component: SeriesLayout,
})
